/**
 * Route for `igaming-negative-carryover-toggle`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingNegativeCarryoverTogglePage } from "../features/igaming-negative-carryover-toggle/IgamingNegativeCarryoverTogglePage";

export const igamingNegativeCarryoverToggleRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-negative-carryover-toggle",
	component: IgamingNegativeCarryoverTogglePage,
});

export default igamingNegativeCarryoverToggleRoute;
